import React from "react";
import img from "./imgs/logo_black.png";
import { CATEGORIES_ARABIC } from "../constants/categories";
import { ORDER_STATUS_ARABIC } from "../constants/orderStatuses";

const StatsGrid = ({ total, active, completed, byStatus, byCategory }) => {

  return (
    <div className="main-stats">
      <div className="header-card">
        <div className="logo-placeholder"><img src={img} alt="logo" width="200px"></img></div>
        <h2>لوحة المعلومات</h2>
      </div>

      <div className="stats-grid-card">
        {/* الصف العلوي: الأرقام الكبيرة */}
        <div className="summary-row">
          <StatItem label="العدد الكلي" value={total} color="#8B5A2B" />
          <StatItem label="قيد التنفيذ" value={active} color="#e67e22" />
          <StatItem label="المكتملة" value={completed} color="#27ae60" />
        </div>

        {/* الصف السفلي: التفاصيل */}
        <div className="details-wrapper">
          <DetailsSection title="توزيع الطلبات حسب الحالة" data={byStatus} formatter={ORDER_STATUS_ARABIC} />
          <DetailsSection title="توزيع الطلبات حسب الصنف" data={byCategory} formatter={CATEGORIES_ARABIC}/>
        </div>
      </div>
    </div>
  );
};

// مكونات صغيرة مساعدة (Helper Components) داخل نفس الملف
const StatItem = ({ label, value, color }) => (
  <div className="stat-item">
    <span className="stat-value" style={{ color }}>{value}</span>
    <span className="stat-label">{label}</span>
  </div>
);

//TODO: this is temporary. Abdi will send them all as objects not arrays
const DetailsSection = ({ title, data, formatter }) => (
  <div className="details-section">
    <h4>{title}</h4>
    <div className="tags-container">
      {Object.entries(data).map(([key, count]) => {
        console.log("Rendering detail item:", { key, count });
        return (
        <div key={key} className="stat-pill">
          <span>{formatter && formatter[key] ? formatter[key] : key}</span>
          <span className="pill-badge">{count}</span>
        </div>
      )
      }
      )}
      {Object.keys(data).length === 0 && <p className="no-data">لا توجد بيانات</p>}
    </div>
  </div>
);

export default StatsGrid;